import React from "react";
import {
  PlusOutlined,
  DeleteOutlined,
  EyeFilled,
  EditOutlined,
} from "@ant-design/icons";
import TableHeaderActions from "./TableHeaderActions";
import { CustomDataTable } from "@/components/UI/Tables/Datatable";

const PermissionTable = ({
  permissionsData,
  selectedRowKeys,
  setSelectedRowKeys,
  searchValue,
  isFetching,
  onAddPermission,
  onRemovePermission,
  onImportPermissions,
  onViewPermission,
  onEditPermission,
  tabs,
  activeTab,
  onTabChange,
  onBulkDelete,
  onBulkEdit,
  onSearchChange,
  // NEW: Pagination props
  paginationInfo = {},
  onPageChange,
  onPageSizeChange,
}) => {
  const permissionsColumns = [
    {
      title: "Permission Name",
      dataIndex: "name",
      key: "name",
      width: 250,
      render: (text) => (
        <span className="font-semibold text-gray-900">{text}</span>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 400,
      render: (text) => <span className="text-gray-600">{text || "-"}</span>,
    },
  ];

  const actionButtons = [
    {
      label: "Add Permission",
      type: "primary",
      icon: <PlusOutlined />,
      onClick: onAddPermission,
      className: "bg-orange-500 border-orange-500 hover:bg-orange-600",
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys) => setSelectedRowKeys(keys),
  };

  const headerActions = [
    {
      label: "Bulk Edit",
      icon: <EditOutlined />,
      type: "primary",
      onClick: () => onBulkEdit?.(selectedRowKeys),
      disabled: selectedRowKeys.length === 0,
    },
    {
      label: "Bulk Delete",
      icon: <DeleteOutlined />,
      type: "default",
      danger: true,
      onClick: () => onBulkDelete?.(selectedRowKeys),
      disabled: selectedRowKeys.length === 0,
    },
  ];

  const handleClearSelection = () => setSelectedRowKeys([]);

  const rowActions = [
    {
      label: "View",
      icon: <EyeFilled />,
      onClick: (record) => onViewPermission?.(record),
    },
    {
      label: "Edit",
      icon: <EditOutlined />,
      onClick: (record) => onEditPermission?.(record),
    },
    {
      label: "Delete",
      icon: <DeleteOutlined />,
      danger: true,
      onClick: (record) => onRemovePermission?.(record),
    },
  ];

  return (
    <div>
      <TableHeaderActions
        selectedCount={selectedRowKeys.length}
        totalCount={paginationInfo.total || permissionsData.length}
        actions={headerActions}
        onClearSelection={handleClearSelection}
      />

      <CustomDataTable
        title="Permission Management"
        data={permissionsData}
        columns={permissionsColumns}
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={onTabChange}
        showSearch={true}
        searchPlaceholder="Search permissions..."
        searchValue={searchValue}
        searchMode="server"
        onServerSearch={onSearchChange}
        actionButtons={actionButtons}
        showFilter={false}
        showCSV={true}
        onFilterClick={() => console.log("Filter clicked")}
        onCSVClick={() => console.log("CSV clicked")}
        rowSelection={rowSelection}
        selectedRowKeys={selectedRowKeys}
        rowActions={rowActions}
        loading={isFetching}
        pagination={true}
        pageSizeOptions={["10", "20", "50", "100"]}
        // Server-side pagination
        paginationMode="server"
        currentPage={paginationInfo.current_page || 1}
        totalItems={paginationInfo.total || 0}
        serverPageSize={paginationInfo.per_page || 10}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
    </div>
  );
};

export default PermissionTable;
